import axios from "axios";

export default {
  name: "ResourceComponent",
  components: {},
  props: [
    "p_visitId",
    "FetchTableData" 
  ],

  data() {
    return {
      showThisModel: false,

      patResSumm: [],

      // pagination
      pagerows: 10,
      totalrows: 0,

      loading: false,
    };
  }, // data
  methods: {
    async onPage(e) {
      this.intDummyComm();

      this.dummyComm.visitId = this.p_visitId;
      this.dummyComm.pageNumber = e.page + 1;
      this.dummyComm.pageSize = e.rows;
      this.pagerows = e.rows;

      this.loading = true;
      const url = this.SERVER + "/STDS/StageDisplay/GetResourceList";
      await this.axiosGetData(url, this.dummyComm).then(res => {
        this.totalrows = res.totalRecords;
        this.patResSumm = res.resources;
      });
      this.loading = false;
    },

    isCapturedClick(val) {
      if (val.available < 1) {
        
        if (!val.isCaptured) {
          this.showErrorToast("Insufficient Resources available.");
          val.isCaptured = false;
        }
      }
    },

    async updateResourcesClick() {
      this.intDummyComm();
      this.dummyComm.visitId = this.p_visitId;
      this.dummyComm.pageNumber = 0;
      this.dummyComm.pageSize = this.pagerows;

      const data = {
        dc: this.dummyComm,
        resources: this.patResSumm,
      };

      this.loading = true;
      const url = this.SERVER + "/STDS/StageDisplay/UpdateResourceList";
      await this.axiosGetData(url, data).then(res => {
        this.totalrows = res.totalRecords;
        this.patResSumm = res.resources;

        let patres = this.patResSumm;
        for (let i = 0; i < patres.length; i++) {
          patres[i].orgIsCaptuted = patres[i].isCaptured;
        }
        this.showSuccessToast("Resource Updated.");
      });
      this.loading = false;

    },

    async loadInit() {
      this.intDummyComm();
      this.dummyComm.visitId = this.p_visitId;
      this.dummyComm.pageNumber = 0;
      this.dummyComm.pageSize = this.pagerows;

      this.loading = true;
      const url = this.SERVER + "/STDS/StageDisplay/GetResourceList";
      await this.axiosGetData(url, this.dummyComm).then(res => {
        this.totalrows = res.totalRecords;
        this.patResSumm = res.resources;

        let patres = this.patResSumm;
        for (let i = 0; i < patres.length; i++) {
          patres[i].orgIsCaptuted = patres[i].isCaptured;
        }
      });
      this.loading = false;
    },

    // closeModal() {
    //   this.showThisModel = false;
    //   this.$emit('close-modal', false);
    //   //$("#add_folder").modal("hide");
    // },

    async axiosGetData(myUrl, myData) {
      let data = "err";
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        contentType: "application/json",
        dataType: "json",
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          data = res.data;
        })
        .catch(function (err) { console.log(err); })
        .finally(/**/() => {
          try{
          this.FetchTableData();
          }
          catch(err)
          {
            console.log(err);
          }        
        });

      return data;
    }, // axiosGetData
  }, // methods

  mounted() {
    this.loadInit();
    this.showThisModel = true;
  },

  watch: {
  }, // watch
}